import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "works-list-component" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "hover-item" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { href: "javascript:;" }
const _hoisted_8 = { class: "tag-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_EllipsisOutlined = _resolveComponent("EllipsisOutlined")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_a_skeleton, {
          key: 0,
          active: "",
          class: "mb-6"
        }))
      : (_openBlock(), _createBlock(_component_a_row, {
          key: 1,
          gutter: 16
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                key: item.id,
                span: 6,
                class: "poster-item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { hoverable: "" }, {
                    cover: _withCtx(() => [
                      (item.coverImg)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.coverImg
                          }, null, 8, _hoisted_2))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.DEFAULT_COVER_IMAGE
                          }, null, 8, _hoisted_3)),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_router_link, {
                          to: `/editor/${item.id}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              size: "large",
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 继续编辑该作品 ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]),
                    actions: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: `/editor/${item.id}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EditOutlined, { key: "edit" })
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_a_dropdown, null, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, { class: "overlay-dropdown" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: "javascript:;",
                                    onClick: _withModifiers(($event: any) => (_ctx.copyClicked(item.id)), ["prevent"])
                                  }, [
                                    _createVNode(_component_CopyOutlined),
                                    _createTextVNode(" 复制")
                                  ], 8, _hoisted_5)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_menu_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: "javascript:;",
                                    onClick: _withModifiers(($event: any) => (_ctx.deleteClicked(item.id)), ["prevent"])
                                  }, [
                                    _createVNode(_component_DeleteOutlined),
                                    _createTextVNode(" 删除")
                                  ], 8, _hoisted_6)
                                ]),
                                _: 2
                              }, 1024),
                              (item.coverImg)
                                ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", _hoisted_7, [
                                        _createVNode(_component_DownloadOutlined),
                                        _createTextVNode(" 下载图片")
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_EllipsisOutlined, { key: "ellipsis" })
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_card_meta, {
                        title: item.title
                      }, null, 8, ["title"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_8, [
                    (item.status === 1)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 未发布 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (item.status === 2)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 已发布 ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
  ]))
}